 import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)
/*import Vue from 'vue'
import Vue2Touch from 'vue2-touch'
Vue.use(Vue2Touch)*/
